import script from "./contactIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./contactIndex.vue?vue&type=script&setup=true&lang=js"

import "./contactIndex.vue?vue&type=style&index=0&id=0bfff0f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfff0f4"]])

export default __exports__